import { useContactSectionContent } from './useContactSectionContent';
import { parseContactPartnerContent } from '../utils/contactContent';

export const useContactPartnerContent = () => useContactSectionContent(parseContactPartnerContent);
